import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RoutesList } from '../../../../routes/Routes';
import { usePlanningBreachStore } from '../../../../hooks/usePlanningBreachStore';
import { ErrorMessages } from '@types';
import { parseZodErrors, textAreaInputSchema } from '@utils';
import { ZodError } from 'zod';
import { TextAreaTemplate } from '@templates';
import { TEXT_AREA_MAX_LENGTH } from '@constants';

export const WorksProblem = () => {
  const { data, update } = usePlanningBreachStore();
  const navigate = useNavigate();
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);
  const labelText = 'How are the works causing a problem?';
  const description = 'For example, working outside allowed hours.';

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    update('problemInfo', event.currentTarget.value);
    setErrorMessages([]);
  };

  const buttonNext = {
    onClick: () => {
      try {
        textAreaInputSchema({
          fieldName: 'problemInfo',
          requiredMessage: 'Enter details about the issue.',
          maxLength: TEXT_AREA_MAX_LENGTH,
          maxLengthMessage: `Details about the issue must be ${TEXT_AREA_MAX_LENGTH} characters or less.`,
        }).parse({
          problemInfo: data.problemInfo,
        });
        navigate(RoutesList.ANY_MORE_INFO);
      } catch (error) {
        const validationErrors = parseZodErrors(error as ZodError);
        setErrorMessages(
          validationErrors.map((error: ErrorMessages) => ({
            ...error,
            href: error.path,
          })),
        );
      }
    },
  };

  const buttonPrevious = {
    label: 'Previous',
    onClick: () => navigate(RoutesList.WORKS_RESPONSIBILITY),
  };

  return (
    <TextAreaTemplate
      labelText={labelText}
      description={description}
      initialTextValue={data.problemInfo}
      errorPath={'problemInfo'}
      errorMessages={errorMessages}
      maxLength={TEXT_AREA_MAX_LENGTH}
      onChange={handleChange}
      buttonNext={buttonNext}
      buttonPrevious={buttonPrevious}
    />
  );
};
